import React from 'react';
import { Link } from 'react-router-dom';
import { useLogoutMutation } from '@/queries/auth/useLogoutMutation';

export default function HeaderComponent({ withHeader }) {
  const logoutMutation = useLogoutMutation();

  const logout = () => {
    logoutMutation.mutate();
  };

  if (!withHeader) {
    return null;
  }

  return (
    <header className="sticky top-0 z-[2001] w-full border-b border-black/[0.08] bg-white/65 backdrop-blur-xl supports-[backdrop-filter]:bg-white/55">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between gap-4 px-4 py-3 md:px-6">
        <Link
          className="inline-flex min-h-0 min-w-0 shrink items-center no-underline"
          to="/"
        >
          <span className="text-xl font-bold tracking-tight text-[#121212]">
            Festyland
          </span>
        </Link>
        <button
          type="button"
          disabled={logoutMutation.isPending}
          className="inline-flex min-h-11 min-w-[9rem] shrink-0 items-center justify-center rounded-[var(--bethere-radius-md)] bg-[var(--bethere-accent)] px-6 font-bold text-[#121212] shadow-sm transition hover:bg-[var(--bethere-secondary)] hover:shadow-md disabled:opacity-60"
          onClick={logout}
        >
          Log Out
        </button>
      </div>
    </header>
  );
}
